/**
 * 首页右下角「猫猫 Loading」SVG 切片弯曲 + 弹跳，退场黄幕上扫。
 * DOM 约定见 c27-home-page-loader.liquid
 *
 * 调试：首页 URL 加 ?c27loaderdebug=1 ，或提前执行 window.C27_HOME_LOADER_DEBUG = true
 */
(function () {
  function isC27LoaderDebug() {
    try {
      if (window.C27_HOME_LOADER_DEBUG === true) return true;
      var s = window.location && window.location.search;
      return !!(s && /\bc27loaderdebug=1(?:&|$)/.test(s));
    } catch (e) {
      return false;
    }
  }

  function dbg() {
    if (!isC27LoaderDebug()) return;
    var ts = new Date().toISOString();
    var rest = Array.prototype.slice.call(arguments);
    console.log.apply(console, ['[C27 home-loader]', ts].concat(rest));
  }

  function dbgSweep(el, phase) {
    if (!isC27LoaderDebug()) return;
    if (!el) {
      console.warn('[C27 home-loader]', phase, 'sweep element is NULL');
      return;
    }
    var cs = window.getComputedStyle(el);
    var r = el.getBoundingClientRect();
    console.groupCollapsed('[C27 home-loader] sweep · ' + phase);
    console.log('BBox', { left: r.left, top: r.top, width: r.width, height: r.height, bottom: r.bottom });
    console.log('computed', {
      display: cs.display,
      visibility: cs.visibility,
      opacity: cs.opacity,
      zIndex: cs.zIndex,
      transform: cs.transform,
      transformOrigin: cs.transformOrigin,
      backgroundColor: cs.backgroundColor,
      backgroundImage: cs.backgroundImage,
      mixBlendMode: cs.mixBlendMode,
      isolation: cs.isolation,
      position: cs.position,
      pointerEvents: cs.pointerEvents
    });
    console.log('animate API', typeof el.animate);
    console.log('node', el);
    console.groupEnd();
    dbgSweepDigest(el, phase);
  }

  /** 单行汇总：无需点开上面折叠组即可截图 / 粘贴给开发 */
  function dbgSweepDigest(el, phase) {
    if (!isC27LoaderDebug() || !el) return;
    var cs = window.getComputedStyle(el);
    var r = el.getBoundingClientRect();
    console.info('[C27 home-loader] sweep digest · ' + phase, {
      boxPx: {
        w: Math.round(r.width),
        h: Math.round(r.height),
        left: Math.round(r.left),
        top: Math.round(r.top),
        right: Math.round(r.right),
        bottom: Math.round(r.bottom),
        vw: typeof window.innerWidth === 'number' ? window.innerWidth : null,
        vh: typeof window.innerHeight === 'number' ? window.innerHeight : null
      },
      pos: cs.position,
      zi: cs.zIndex,
      opacity: cs.opacity,
      visibility: cs.visibility,
      display: cs.display,
      bg: cs.backgroundColor,
      transform: cs.transform,
      clipPath: cs.clipPath,
      filter: cs.filter,
      mixBlendMode: cs.mixBlendMode
    });
  }

  function ensureInit() {
    var root = document.getElementById('c27-home-loader');
    if (!root) {
      if (isC27LoaderDebug()) console.warn('[C27 home-loader] ensureInit skip: no #c27-home-loader');
      return;
    }
    if (root.getAttribute('data-c27-cat-loaded') === '1') {
      if (isC27LoaderDebug()) dbg('ensureInit skip: already initialized');
      return;
    }

    var urlUp =
      root.getAttribute('data-c27-loader-up') ||
      '';
    var urlBtm =
      root.getAttribute('data-c27-loader-btm') ||
      '';

    var SVG_NS = 'http://www.w3.org/2000/svg';
    var bendSvg = root.querySelector('.c27-home-cat-loader__bend');
    var defs = bendSvg ? bendSvg.querySelector('defs') : null;
    var colsHost = bendSvg ? bendSvg.querySelector('.c27-cat-loader__cols') : null;
    if (!bendSvg || !defs || !colsHost) {
      console.warn('[C27 home-loader] ABORT ensureInit: SVG 结构缺失（猫不会动、也无退场绑定）', {
        bendSvg: !!bendSvg,
        defs: !!defs,
        colsHost: !!colsHost
      });
      dbg('ABORT ensureInit detail', { bendSvg: !!bendSvg, defs: !!defs, colsHost: !!colsHost });
      return;
    }

    root.setAttribute('data-c27-cat-loaded', '1');

    var imgCat = defs.querySelector('.c27-cat-loader__cat-el');
    var imgLbl = defs.querySelector('.c27-cat-loader__label-el');

    if (imgCat && urlUp) imgCat.setAttributeNS('http://www.w3.org/1999/xlink', 'href', urlUp);
    if (imgCat && urlUp) imgCat.setAttribute('href', urlUp);
    if (imgLbl && urlBtm) imgLbl.setAttributeNS('http://www.w3.org/1999/xlink', 'href', urlBtm);
    if (imgLbl && urlBtm) imgLbl.setAttribute('href', urlBtm);

    var catBounce = document.getElementById('c27-cat-bounce');
    var catSource = document.getElementById('c27-cat-source');
    var labelSource = document.getElementById('c27-label-source');
    var sweepOuter = root.querySelector('.c27-home-loader__sweep');
    dbg('ensureInit ok', {
      rootId: root.id,
      hasSweep: !!sweepOuter,
      hasBendSvg: !!bendSvg,
      hasAnimate: !!(sweepOuter && typeof sweepOuter.animate === 'function')
    });
    dbgSweep(sweepOuter, 'idle (before loop)');

    var BASE_DUR = 2200;
    var VB_W = 191;
    var VB_H = 244;
    var N = 32;
    var cols = [];

    function buildCols(n) {
      cols.forEach(function (c) {
        if (c && c.parentNode) c.parentNode.removeChild(c);
      });
      cols = [];
      Array.prototype.forEach.call(defs.querySelectorAll('clipPath[id^="c27-col-clip-"]'), function (c) {
        if (c.parentNode) c.parentNode.removeChild(c);
      });

      var colW = VB_W / n;
      for (var i = 0; i < n; i++) {
        var cp = document.createElementNS(SVG_NS, 'clipPath');
        cp.setAttribute('id', 'c27-col-clip-' + i);
        var rect = document.createElementNS(SVG_NS, 'rect');
        rect.setAttribute('x', (i * colW - 0.25).toFixed(3));
        rect.setAttribute('y', '-400');
        rect.setAttribute('width', (colW + 0.5).toFixed(3));
        rect.setAttribute('height', '1000');
        cp.appendChild(rect);
        defs.appendChild(cp);

        var g = document.createElementNS(SVG_NS, 'g');
        g.setAttribute('class', 'c27-col');
        g.setAttribute('clip-path', 'url(#c27-col-clip-' + i + ')');
        g.setAttribute('transform', 'translate(0 0)');

        var useCat = document.createElementNS(SVG_NS, 'use');
        useCat.setAttribute('href', '#c27-cat-source');
        g.appendChild(useCat);
        var useLbl = document.createElementNS(SVG_NS, 'use');
        useLbl.setAttribute('href', '#c27-label-source');
        g.appendChild(useLbl);

        colsHost.appendChild(g);
        cols.push(g);
      }
    }
    buildCols(N);

    function bell(x) {
      var v = 4 * x * (1 - x);
      return v < 0 ? 0 : v;
    }

    function applyBend(depth) {
      var nCol = cols.length;
      var colW = VB_W / nCol;
      for (var i = 0; i < nCol; i++) {
        var xL = i * colW;
        var xR = xL + colW;
        var dyL = depth * bell(xL / VB_W);
        var dyR = depth * bell(xR / VB_W);
        var m = (dyR - dyL) / colW;
        var f = dyL - m * xL;
        cols[i].setAttribute('transform', 'matrix(1 ' + m.toFixed(5) + ' 0 1 0 ' + f.toFixed(3) + ')');
      }
    }

    function bezier(p1x, p1y, p2x, p2y) {
      return function (t) {
        var x = t;
        for (var ii = 0; ii < 6; ii++) {
          var fe = 3 * (1 - x) * (1 - x) * x * p1x + 3 * (1 - x) * x * x * p2x + x * x * x - t;
          var d = 3 * (1 - x) * (1 - x) * p1x + 6 * (1 - x) * x * (p2x - p1x) + 3 * x * x * (1 - p2x);
          if (Math.abs(d) < 1e-7) break;
          x -= fe / d;
          if (x < 0) x = 0;
          else if (x > 1) x = 1;
        }
        return 3 * (1 - x) * (1 - x) * x * p1y + 3 * (1 - x) * x * x * p2y + x * x * x;
      };
    }

    var EASE_FALL = bezier(0.5, 0, 0.9, 0.4);
    var EASE_HOLD = bezier(0.4, 0, 0.6, 1);
    var EASE_REBOUND = bezier(0.2, 0.8, 0.4, 1);
    var EASE_RISE = bezier(0.3, 0, 0.5, 1);
    var EASE_REBOUND_HARD = bezier(0.18, 0.85, 0.32, 1);
    var EASE_LIFTOFF = bezier(0.85, 0, 1, 1);
    var LINEAR = function (t) {
      return t;
    };

    var BOUNCE_FRAMES = [
      { t: 0.0, ty: -140, sx: 1.0, sy: 1.0, ease: LINEAR },
      { t: 0.12, ty: -70, sx: 0.9, sy: 1.1, ease: EASE_FALL },
      { t: 0.24, ty: -15, sx: 0.85, sy: 1.15, ease: EASE_FALL },
      { t: 0.3, ty: 0, sx: 0.92, sy: 1.12, ease: EASE_HOLD },
      { t: 0.4, ty: 0, sx: 1.3, sy: 0.7, ease: EASE_HOLD },
      { t: 0.5, ty: 0, sx: 0.95, sy: 1.08, ease: EASE_REBOUND },
      { t: 0.56, ty: -15, sx: 0.85, sy: 1.15, ease: EASE_HOLD },
      { t: 0.7, ty: -70, sx: 0.9, sy: 1.1, ease: EASE_RISE },
      { t: 0.85, ty: -115, sx: 0.95, sy: 1.05, ease: EASE_RISE },
      { t: 1.0, ty: -140, sx: 1.0, sy: 1.0, ease: EASE_RISE }
    ];

    var FLYOUT_FRAMES = [
      { t: 0.0, ty: -140, sx: 1.0, sy: 1.0, op: 1, ease: LINEAR },
      { t: 0.135, ty: -70, sx: 0.9, sy: 1.1, op: 1, ease: EASE_FALL },
      { t: 0.18, ty: 0, sx: 0.92, sy: 1.1, op: 1, ease: EASE_FALL },
      { t: 0.345, ty: 0, sx: 1.45, sy: 0.55, op: 1, ease: EASE_HOLD },
      { t: 0.4, ty: 0, sx: 1.45, sy: 0.55, op: 1, ease: LINEAR },
      { t: 0.46, ty: -25, sx: 0.85, sy: 1.2, op: 1, ease: EASE_REBOUND_HARD },
      { t: 0.7, ty: -800, sx: 0.55, sy: 1.55, op: 1, ease: EASE_LIFTOFF },
      { t: 1.0, ty: -2400, sx: 0.5, sy: 1.55, op: 0, ease: LINEAR }
    ];

    var DIP_STOPS = [
      [0.0, 0],
      [0.28, 0],
      [0.4, 22],
      [0.5, 10],
      [0.58, -3],
      [0.68, 0],
      [1.0, 0]
    ];

    var FINISH_DIP_STOPS = [
      [0.0, 0],
      [0.18, 0],
      [0.3, 38],
      [0.345, 42],
      [0.4, 42],
      [0.46, -8],
      [0.52, 0],
      [1.0, 0]
    ];

    function finishDipAt(ft) {
      for (var i = 0; i < FINISH_DIP_STOPS.length - 1; i++) {
        var a = FINISH_DIP_STOPS[i];
        var b = FINISH_DIP_STOPS[i + 1];
        if (ft >= a[0] && ft <= b[0]) {
          var k = (ft - a[0]) / (b[0] - a[0] || 1);
          return a[1] + (b[1] - a[1]) * k;
        }
      }
      return 0;
    }

    function interpolateFrames(frames, t) {
      for (var i = 0; i < frames.length - 1; i++) {
        var a = frames[i];
        var b = frames[i + 1];
        if (t >= a.t && t <= b.t) {
          var kk = (b.t - a.t) === 0 ? 0 : (t - a.t) / (b.t - a.t);
          var ek = b.ease(kk);
          return {
            ty: a.ty + (b.ty - a.ty) * ek,
            sx: a.sx + (b.sx - a.sx) * ek,
            sy: a.sy + (b.sy - a.sy) * ek,
            op: (a.op == null ? 1 : a.op) + ((b.op == null ? 1 : b.op) - (a.op == null ? 1 : a.op)) * ek
          };
        }
      }
      var last = frames[frames.length - 1];
      return { ty: last.ty, sx: last.sx, sy: last.sy, op: last.op == null ? 1 : last.op };
    }

    function dipScaleAt(t) {
      for (var i = 0; i < DIP_STOPS.length - 1; i++) {
        var a = DIP_STOPS[i];
        var b = DIP_STOPS[i + 1];
        if (t >= a[0] && t <= b[0]) {
          var k = (t - a[0]) / (b[0] - a[0] || 1);
          return a[1] + (b[1] - a[1]) * k;
        }
      }
      return 0;
    }

    function getRate() {
      var v = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--c27-home-loader-rate')
      );
      return isFinite(v) && v > 0 ? v : 1;
    }

    function setCat(ty, sx, sy, op) {
      catBounce.setAttribute(
        'transform',
        'translate(0 ' + ty.toFixed(2) + ') ' +
          'translate(95.5 180) ' +
          'scale(' +
          sx.toFixed(4) +
          ' ' +
          sy.toFixed(4) +
          ') ' +
          'translate(-95.5 -180)'
      );
      if (op != null && catSource) {
        catSource.style.opacity = String(op);
      }
    }

    var clockVirtual = 0;
    var lastReal = performance.now();
    var finishing = false;
    var finishStart = 0;
    var hideTimer = null;
    var underlayHideTimer = null;
    var rafId = 0;

    function tick(now) {
      now = performance.now();
      var rate = getRate();
      if (!finishing) {
        clockVirtual += (now - lastReal) * rate;
      }
      lastReal = now;

      var dipDepth;
      if (finishing) {
        var ft = Math.min(1, (now - finishStart) / 1300);
        var f = interpolateFrames(FLYOUT_FRAMES, ft);
        setCat(f.ty, f.sx, f.sy, f.op);
        dipDepth = finishDipAt(ft);
      } else {
        var tNorm = ((clockVirtual % BASE_DUR) + BASE_DUR) % BASE_DUR / BASE_DUR;
        var f2 = interpolateFrames(BOUNCE_FRAMES, tNorm);
        setCat(f2.ty, f2.sx, f2.sy, 1);
        dipDepth = dipScaleAt(tNorm);
      }

      applyBend(dipDepth);
      rafId = window.requestAnimationFrame(tick);
    }

    function startLoop() {
      lastReal = performance.now();
      rafId = window.requestAnimationFrame(tick);
    }

    function beginFinish(removeCallback) {
      if (finishing) return;
      finishing = true;
      finishStart = performance.now();

      dbg('beginFinish', { t0: finishStart, perfNow: performance.now() });
      dbgSweep(sweepOuter, 'beginFinish · before class --finishing');

      root.classList.add('c27-home-page-loader-shell--finishing');

      /* delay 600 + sweep 700 + 退场余量 — 必须与下方 WAA 总时长对齐，避免 DOM 早于黄幕摘掉 */
      var REMOVE_MS = 2600;

      /*
       * 黄幕铺满视口 ≈ sweepDelayMs + round(duration × first translateY(0) keyframeOffset)，与下方 WAA/fallback 一致。
       */
      var sweepDelayMs = 600;
      var sweepActiveMs = 1300;
      var sweepKeyframeCoverOffset = 5384615 / 1e7;
      var sweepMoveMs = Math.round(sweepActiveMs * sweepKeyframeCoverOffset);
      var underlayHideAfterMs = sweepDelayMs + sweepMoveMs;

      hideTimer = window.setTimeout(removeCallback || function () {}, REMOVE_MS);

      if (underlayHideTimer) {
        window.clearTimeout(underlayHideTimer);
        underlayHideTimer = null;
      }
      underlayHideTimer = window.setTimeout(function () {
        underlayHideTimer = null;
        root.classList.add('c27-home-page-loader-shell--under-cover');
      }, underlayHideAfterMs);

      if (catSource) catSource.style.opacity = '';
      if (labelSource) labelSource.style.opacity = '';

      /*
       * 黄幕必须用 WAA（或兜底 transition）——纯 CSS animation 易被主题/transform 规则压住，
       * 浏览器里就只看见猫飞出、黄幕不出现。
       */
      function fallbackSweepTransitions() {
        dbg('sweep: using CSS transition fallback');
        if (!sweepOuter) return;
        sweepOuter.style.transition = 'none';
        sweepOuter.style.transform = 'translateY(100%)';
        sweepOuter.style.opacity = '1';
        void sweepOuter.offsetWidth;
        window.setTimeout(function () {
          dbgSweep(sweepOuter, 'fallback · t=600ms before setting transition');
          var opacityLagMs = sweepDelayMs + sweepMoveMs - 450;
          if (opacityLagMs < 0) opacityLagMs = sweepDelayMs;
          sweepOuter.style.transition =
            'transform ' +
            sweepMoveMs +
            'ms cubic-bezier(0.55, 0.05, 0.4, 1), opacity 350ms linear ' +
            opacityLagMs +
            'ms';
          sweepOuter.style.transform = 'translateY(0)';
          sweepOuter.style.opacity = '0';
          window.setTimeout(function () {
            dbgSweep(sweepOuter, 'fallback · after target styles (next frame guess)');
          }, 50);
        }, sweepDelayMs);
      }

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          dbgSweep(sweepOuter, 'RAF before WAA');
          if (!sweepOuter) {
            dbg('sweep: MISSING .c27-home-loader__sweep — DOM 与 liquid 是否一致？');
            return;
          }
          try {
            if (typeof sweepOuter.animate === 'function') {
              sweepOuter.style.animation = 'none';
              dbg('sweep: starting Web Animations API', {
                duration: sweepActiveMs,
                delay: sweepDelayMs
              });
              var sweepAnim = sweepOuter.animate(
                [
                  { transform: 'translateY(100%)', opacity: 1 },
                  { transform: 'translateY(0)', opacity: 1, offset: sweepKeyframeCoverOffset },
                  { transform: 'translateY(0)', opacity: 1, offset: 0.7692307 },
                  { transform: 'translateY(0)', opacity: 0 }
                ],
                {
                  duration: sweepActiveMs,
                  delay: sweepDelayMs,
                  easing: 'cubic-bezier(0.55, 0.05, 0.4, 1)',
                  fill: 'forwards',
                  iterations: 1
                }
              );
              if (sweepAnim && sweepAnim.ready && typeof sweepAnim.ready.then === 'function') {
                sweepAnim.ready.then(
                  function () {
                    dbg('sweep WAA: ready (first frame committed)');
                    dbgSweep(sweepOuter, 'after WAA ready');
                  },
                  function (err) {
                    dbg('sweep WAA: ready rejected', err);
                  }
                );
              }
              if (sweepAnim && sweepAnim.finished && typeof sweepAnim.finished.then === 'function') {
                sweepAnim.finished.then(
                  function () {
                    dbg('sweep WAA: finished');
                    dbgSweep(sweepOuter, 'after WAA finished');
                  },
                  function (err) {
                    dbg('sweep WAA: finished rejected', err);
                  }
                );
              }
              if (isC27LoaderDebug()) {
                [850, 1450, 2100].forEach(function (delay) {
                  window.setTimeout(function () {
                    dbg('sweep WAA sample', { delayMs: delay, playState: sweepAnim ? sweepAnim.playState : 'no-anim' });
                    dbgSweep(sweepOuter, 'WAA t≈' + delay + 'ms');
                  }, delay);
                });
              }
            } else {
              dbg('sweep: Element.animate 不存在，走 fallback');
              fallbackSweepTransitions();
            }
          } catch (eSweep) {
            console.error('[C27 home-loader] sweep WAA error', eSweep);
            fallbackSweepTransitions();
          }
        });
      });
    }

    root._c27CatLoaderStartLoop = startLoop;
    root._c27CatLoaderBeginFinish = beginFinish;

    root._c27CatLoaderDispose = function () {
      finishing = true;
      if (hideTimer) {
        window.clearTimeout(hideTimer);
        hideTimer = null;
      }
      if (underlayHideTimer) {
        window.clearTimeout(underlayHideTimer);
        underlayHideTimer = null;
      }
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = 0;
      }
    };

    startLoop();
  }

  window.C27BootHomeCatLoader = ensureInit;

  if (document.getElementById('c27-home-loader')) {
    ensureInit();
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureInit);
  } else {
    ensureInit();
  }
})();
